// Radius has no "full"/circle entry in this project's Tailwind scale (theme.borderRadius
// is a closed override, not an extend) — rounded-full resolves to nothing, so full-circle
// shapes here are done via inline style instead of a Tailwind class.
export const CIRCLE_RADIUS = { borderRadius: "9999px" };

// `color` drives the dot + progress bar segment; `textColor` drives the label/amount —
// the light dot colors (approved/pending) would be unreadable as text, so text uses a
// separate, always-legible grayscale.
export const BALANCE_BUCKETS = [
    { key: "settled", color: "#00000073", textColor: "#00000073", bold: false, tooltip: false },
    { key: "available", color: "#008080", textColor: "#000000E0", bold: true, tooltip: false },
    { key: "approved", color: "#BFDFDF", textColor: "#000000A6", bold: false, tooltip: true },
    { key: "pending", color: "#F0F0F0", textColor: "#00000073", bold: false, tooltip: true },
] as const;

export type BalanceBucketKey = (typeof BALANCE_BUCKETS)[number]["key"];
